import React from 'react';
import { LOTTERY_LOGO_MAP } from './lotteryLogosMap';

const LOGO_STYLE = { width: 40, height: 40 };

const FALLBACK_STYLE = {
  width: 40,
  height: 40,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 22,
  borderRadius: '50%',
  background: '#f3f3f3',
};

export const renderLotteryLogo = (lotteryId) => {
  const src = LOTTERY_LOGO_MAP.get(lotteryId);
  if (src) {
    return <img src={src} alt="" style={LOGO_STYLE} />;
  }
  return (
    <span style={FALLBACK_STYLE} aria-hidden="true">
      🎱
    </span>
  );
};
